import 'vant/es/toast/style';
export default {
  data() {
    return {
      lang: 'hk',
      userTerms: [{
        type: 'title',
        hkText: "刪除賬戶確認"
      }, {
        type: 'content',
        hkText: '您在申請永久刪除教圖家長會 ParentNet帳戶流程中點擊同意前，應當認真閱讀、充分理解《教圖家長會 ParentNet帳戶永久刪除須知》（以下簡稱“《永久刪除須知》”）中相關條款內容，其中包括：'
      }, {
        type: 'subT',
        hkText: "1、與您約定免除或限制責任的條款；"
      }, {
        type: 'subT',
        hkText: "2、其他以粗體底線標識的重要條款。"
      }, {
        type: 'content',
        hkText: "如您對本《永久刪除須知》有任何疑問，請通過marketing@hkep.com與我們聯繫。"
      }, {
        type: 'content',
        hkText: '【特別提示】當您按照永久刪除頁面提示填寫資訊、閱讀並同意本《永久刪除須知》及相關條款與條件且完成全部永久刪除流程後，即表示您已充分閱讀、理解並接受本《永久刪除須知》的全部內容。閱讀本《永久刪除須知》的過程中，如果您不同意相關任何條款和條件約定，請您立即停止教圖家長會 ParentNet帳戶永久刪除流程。'
      }, {
        type: 'content',
        hkText: '重要提醒：'
      }, {
        type: 'content',
        hkText: '永久刪除教圖家長會 ParentNet帳戶是不可恢復的操作，永久刪除後您將無法再使用本教圖家長會 ParentNet帳戶登錄ParentNet用戶端、PC端和WAP端，無法找回您在教圖家長會 ParentNet留下的瀏覽歷史、收藏、評論、積分等資訊。即使您使用相同的手機號再次註冊並使用教圖家長會 ParentNet，原帳戶資訊也無法找回。'
      }, {
        type: 'content',
        hkText: '建議您在永久刪除前，自行備份在教圖家長會 ParentNet的所有相關資訊，確認與帳戶相關的所有服務均已妥善處理。'
      }, {
        type: 'subT',
        hkText: '1.為保證您的帳戶安全，在提交永久刪除申請前，您的帳戶需要滿足以下條件：'
      }, {
        type: 'content',
        hkText: '1.1 帳戶處於安全狀態'
      }, {
        type: 'content',
        hkText: '為了保證您的帳戶不存在被盜、被封或其他丟失風險，我們將在您提交永久刪除流程時對您帳戶綁定的手機號/電郵地址進行短信/電郵驗證，請確認您綁定的手機號能正常接收驗證短信/電郵地址能正常接收電子郵件。'
      }, {
        type: 'content',
        hkText: '1.2 內財產已結清'
      }, {
        type: 'content',
        hkText: '帳戶中沒有資產、欠款、未結清的資金和虛擬權益。'
      }, {
        type: 'content',
        hkText: '1.3 帳戶無任何糾紛，包括投訴舉報或被投訴舉報'
      }, {
        type: 'subT',
        hkText: '2.永久刪除帳戶後，您將無法再使用本帳戶，也無法找回本帳戶相關的任何內容或資訊，包括但不限於：'
      }, {
        type: 'content',
        hkText: '2.1 本教圖家長會 ParentNet的個人資料和歷史資訊（包括但不限於頭像、用戶名、發佈內容、瀏覽記錄、關注、積分、收藏等）都將無法找回；'
      }, {
        type: 'content',
        hkText: '2.2 您通過本教圖家長會 ParentNet帳戶使用、授權登錄或綁定本教圖家長會 ParentNet帳戶後使用的教圖家長會 ParentNet或協力廠商服務的相關資訊將無法找回。您將無法再登錄、使用上述服務，您曾獲得的虛擬權益等財產性利益視為您自動放棄，將無法繼續使用。'
      }, {
        type: 'subT',
        hkText: '3.在您帳戶永久刪除期間，如您的帳戶被他人投訴、被香港特區政府調查或者正處於訴訟、仲裁程式中，教圖家長會 ParentNet有權自行終止您帳戶的永久刪除而無需另行得到您的同意。'
      }, {
        type: 'content',
        hkText: '本網站內容受到知識產權保護。有關內容的編輯（包括內容的搜集、安排及組合）是本網站的獨有產權，受到香港法律的版權法令及國際版權法規保護。用戶有權下載部份內容作為網上訂購貨物或服務之用。其他用途包括複製、修改、分送、傳送、顯示或作表演用途均嚴格禁止，如法例許可除外。'
      }, {
        type: 'subT',
        hkText: '4.永久刪除本教圖家長會 ParentNet帳戶並不代表永久刪除前帳戶中的行為和相關責任得到豁免或減輕。'
      }, {
        type: 'subT',
        hkText: '5.刪除步驟:'
      }, {
        type: 'content',
        hkText: '5.1 在主頁點擊用戶頭像進入我的頁面。'
      }, {
        type: 'content',
        hkText: '5.2 我的頁面中點擊"注銷賬戶"按鈕並確認完成刪除。'
      }]
    };
  },
  components: {},
  methods: {}
};